import { useSelector } from 'react-redux'
import { skipToken } from '@reduxjs/toolkit/dist/query'
import { ClaimRecord, ClaimRecordStatus } from '@typesApp/ClaimRecord'
import { useGetClaimRecordQuery, useLazyGetClaimRecordQuery } from '@redux/queries/claimRecords'
import { claimRecordDeletedSelector, claimRecordIdSelector } from '@redux/slices/claimStatusSlice'

type UseClaimRecordReturn = {
  claimRecordId: string
  claimRecord?: ClaimRecord
  claimRecordStatus?: ClaimRecordStatus
  claimRecordDeleted?: boolean
  isLoading?: boolean
  isError?: boolean
  fetchClaimRecord: (preferCache?: boolean) => Promise<ClaimRecord | void>
}

export const useClaimRecord = (): UseClaimRecordReturn => {
  const claimRecordId = useSelector(claimRecordIdSelector)
  const claimRecordDeleted = useSelector(claimRecordDeletedSelector)

  const {
    data: claimRecord,
    isError,
    isFetching,
    isLoading,
    error,
  } = useGetClaimRecordQuery(claimRecordId || skipToken)
  const [triggerFetch] = useLazyGetClaimRecordQuery()

  const fetchClaimRecord = (preferCache?: boolean): Promise<ClaimRecord | void> => {
    if (!claimRecordId) {
      return Promise.resolve()
    }
    return triggerFetch(claimRecordId, preferCache).unwrap()
  }

  return {
    claimRecordId,
    claimRecordDeleted,
    claimRecordStatus: claimRecord?.status,
    claimRecord,
    isError,
    isLoading: isFetching || isLoading,
    fetchClaimRecord,
  }
}
